import { useContext } from "react";
import Tooltip from "@mui/material/Tooltip";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { ClinicaContext } from "../../context/clinica-context";
import { AuthContext } from "../../context/auth-context";
import { podeAlterarRegisto, motivoBloqueioUnidade } from "../../util/unidadeRegisto";
import "./BadgeUnidade.scss";

/**
 * Marca um registo de OUTRA unidade como sendo apenas de leitura.
 *
 * Existia antes como um `<span>` de 11px cinzento escrito à mão em cada sítio.
 * Passava despercebido: as ações desapareciam e a pessoa não percebia porquê,
 * que é exatamente o problema que este aviso devia resolver.
 *
 * Decide sozinho se deve aparecer — recebe só o estabelecimento do registo.
 * Assim não há dois sítios a calcular a mesma condição e a divergirem.
 *
 * O `texto` existe porque nem todas as restrições são iguais. Num orçamento em
 * Débitos o dinheiro pode mexer-se — só a VENDA é que é de outra unidade — e
 * escrever ali "só consulta" seria mentira. Um aviso que exagera ensina as
 * pessoas a desconfiar dele.
 *
 * @param {string} [texto]  o que o selo diz; por omissão "só consulta"
 */
const SeloSoConsulta = ({ estabelecimento, texto = "só consulta" }) => {
  const clinica = useContext(ClinicaContext);
  const auth = useContext(AuthContext);

  // Numa clínica de unidade única isto seria sempre falso e nunca apareceria;
  // a verificação evita o cálculo e deixa a intenção escrita.
  if (!clinica?.clinica?.multiEstabelecimento) return null;
  if (podeAlterarRegisto(estabelecimento, auth)) return null;

  return (
    <Tooltip title={motivoBloqueioUnidade(estabelecimento)}>
      <span className="selo-so-consulta">
        <LockOutlinedIcon className="selo-so-consulta__icone" />
        {texto}
      </span>
    </Tooltip>
  );
};

export default SeloSoConsulta;
